import { LeaveTypeEnum } from "@/types";

export const leaveTypeLabelMap: Record<string, string> = {
  [LeaveTypeEnum.SICK_LEAVE]: "Sick Leave",
  [LeaveTypeEnum.CASUAL_LEAVE]: "Casual Leave",
  [LeaveTypeEnum.PAID_LEAVE]: "Paid Leave",
  [LeaveTypeEnum.COMP_OFF]: "Comp Off",
  [LeaveTypeEnum.UNPAID_LEAVE]: "Unpaid Leave",
  [LeaveTypeEnum.MATERNITY_LEAVE]: "Maternity Leave",
  [LeaveTypeEnum.PATERNITY_LEAVE]: "Paternity Leave",
  [LeaveTypeEnum.BEREAVEMENT_LEAVE]: "Bereavement Leave",
  [LeaveTypeEnum.STUDY_LEAVE]: "Study Leave",
  [LeaveTypeEnum.OTHER]: "Other",
};

export function formatLeaveType(value?: string | null): string {
  if (typeof value !== "string") {
    return "Unknown";
  }

  const normalizedValue = value.trim();

  if (!normalizedValue) {
    return "Unknown";
  }

  return (
    leaveTypeLabelMap[normalizedValue] ||
    normalizedValue
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase())
  );
}

export const leaveTypeOptions = Object.values(LeaveTypeEnum).map((type) => ({
  value: type,
  label: formatLeaveType(type),
}));
